import { DAY, getNewDate, getDaysAgo, getWeeksAgo, getMonthsAgo } from 'utils/date';
import { Presets, TimePreset } from '../types';

/**
 * This is the time range that the BE automatically filters
 * When the startTime and endTime is not specified while querying for data
 */
export const defaultTimePreset = TimePreset.EXPERIMENT_PERIOD;

export const RELATIVE_DATE_PRESETS_WITH_LABELS: Presets = {
  [TimePreset.TODAY]: {
    menuLabel: 'timePresets.menu.today',
    filterLabel: 'timePresets.filter.today',
    format: (timeZone) => ({
      startDate: getNewDate({ timeZone }).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  [TimePreset.PAST_3_DAYS]: {
    menuLabel: 'timePresets.menu.3Days',
    filterLabel: 'timePresets.filter.3Days',
    format: (timeZone) => ({
      startDate: getDaysAgo(getNewDate({ timeZone }), 3).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  [TimePreset.PAST_7_DAYS]: {
    menuLabel: 'timePresets.menu.7Days',
    filterLabel: 'timePresets.filter.7Days',
    format: (timeZone) => ({
      startDate: getWeeksAgo(getNewDate({ timeZone }), 1).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  [TimePreset.PAST_30_DAYS]: {
    menuLabel: 'timePresets.menu.30Days',
    filterLabel: 'timePresets.filter.30Days',
    format: (timeZone) => ({
      startDate: getMonthsAgo(getNewDate({ timeZone }), 1).startOf(DAY),
      endDate: getNewDate({ timeZone }).endOf(DAY),
    }),
  },
  [TimePreset.CUSTOM_RANGE]: {
    menuLabel: 'timePresets.menu.custom',
    filterLabel: 'timePresets.filter.custom',
  },
};

export const WEEK_IN_MINUTES = 168 * 60;
